import { Box, Button, Typography, useMediaQuery } from '@mui/material';
import React from 'react';

interface Props {
    collectionId: string;
    collectionName: string;
    onDelete: (id: string) => void;
    onCancel: () => void;
}

const style = (isMobile: boolean) => {
    return ({
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: isMobile ? 400 : 360,
        bgcolor: '#DAE5F1',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    })
};

const DeleteCollectionConfirm: React.FC<Props> = ({
    collectionId,
    collectionName,
    onDelete,
    onCancel,
}) => {
    const matches = useMediaQuery('(min-width:900px)');

    return (
        <Box sx={style(matches)}>
            <Typography variant='h5' textAlign='center'>Delete Collection</Typography>
            <p>Are you sure you want to delete "{collectionName}"?</p>
            <Button size="medium" type='submit' variant="contained" color="primary" onClick={() => onDelete(collectionId)}>Delete</Button>
            <Button size={matches ? "medium" : "small"} color='secondary' sx={{ ml: 1 }} variant="contained" onClick={onCancel}>Cancel</Button>
        </Box>
    );
};

export default DeleteCollectionConfirm;